import React from 'react';

import { TableCell } from '~/components/bad/DataTables/types.flow';

import ActionColumnCell, {
  ActionListOption,
} from '~/components/bad/DataTables/components/ActionColumnCell';
import useConfirmModal from '~/hooks/useConfirmModal';
import { navigate } from '@gatsbyjs/reach-router';
import TEST_ID from './index.testid';
import formatToastMessage from '~/util/formatToastMessage';
import useAddToast from '~/hooks/useAddToast';
import { useDeleteFormMutation } from '~/graphql/types';
import useCurrentAccount from '~/hooks/useCurrentAccount';

const text = {
  deactivateLabel: 'Deactiveer',
  activateLabel: 'Activeer',
  copyLabel: 'Kopieer formulier',
  deleteLabel: 'Verwijderen',
  deleteErrorMessage:
    'Er is iets misgegaan bij het verwijderen van het formulier. Probeer het nog eens.',
  confirmModalCancelButtonText: 'Annuleren',
  confirmDeleteTitle: 'Formulier verwijderen?',
  confirmDeleteButton: 'Verwijderen',
  confirmDeleteMessage: 'Delete confirm message',
  deleteToast: 'Formulier verwijderd',
};

const confirmDeleteModalText = {
  title: text.confirmDeleteTitle,
  buttonConfirmTitle: text.confirmDeleteButton,
  buttonCancelTitle: text.confirmModalCancelButtonText,
};

type Props = {
  id: string;
  cell: TableCell<any>;
  enabled: boolean;
  name: string;
  onSuccessfulDelete: () => void;
  description?: string;
};
const FormActionColumnCell: React.FC<Props> = ({
  id: id,
  cell,
  name: name,
  description: description = '',
  onSuccessfulDelete,
}) => {
  const addToast = useAddToast();
  const [deleteForm] = useDeleteFormMutation();
  const account = useCurrentAccount();

  const [showDeleteConfirmModal, setOnDeleteConfirmFunction] = useConfirmModal(
    {
      ...confirmDeleteModalText,
      message: text.confirmDeleteMessage,
    },
    () => {},
    () => {},
    TEST_ID.CONFIRM_MODAL,
    false,
    'destructive',
  );

  const options: Array<ActionListOption> = [
    {
      label: text.deleteLabel,
      onClick: () => {
        const deleteFn = () =>
          deleteForm({
            variables: {
              accountId: account.id,
              formBuilderId: id,
            },
          }).then(({ errors }) => {
            if (errors && errors.length !== 0) {
              return addToast([
                formatToastMessage(text.deleteErrorMessage, 'danger'),
              ]);
            }

            onSuccessfulDelete();
            return addToast([formatToastMessage(text.deleteToast, 'success')]);
          });
        setOnDeleteConfirmFunction(deleteFn);
        showDeleteConfirmModal();
      },
      key: 'delete',
      type: 'DELETE',
    },
    {
      label: text.copyLabel,
      onClick: (_rowId: string) => {
        const copiedFormName = `Kopie van ${name}`;

        return navigate(
          `/-/forms/${id}?name=${encodeURIComponent(
            copiedFormName,
          )}&description=${encodeURIComponent(description)}`,
        );
      },
      key: 'copy',
    },
  ];

  return (
    <ActionColumnCell
      key={'contact-action-column-cell'}
      loading={false}
      options={options.reverse()}
      cell={cell}
    />
  );
};

export default FormActionColumnCell;
